import { makeStyles, tokens } from "@fluentui/react-components";
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
/**
 * Base styles for TryPremiumModal component
 */ export const useBaseTryPremiumModalStyles = makeStyles({
    dialogSurface: {
        width: "600px",
        minHeight: "480px",
        maxWidth: "800px",
        padding: "0px",
        border: "0px",
        borderRadius: tokens.borderRadiusXLarge
    },
    root: {
        width: "100%",
        minHeight: "480px"
    },
    closeButtonContainer: {
        width: "600px",
        height: "52px",
        position: "relative"
    },
    closeButton: {
        position: "absolute",
        top: tokens.spacingVerticalS,
        right: tokens.spacingHorizontalS,
        zIndex: "2000"
    },
    startTrialButton: {
        borderRadius: tokens.borderRadiusXLarge
    },
    // Try premium and success content styles
    imageHeaderWrapper: {
        textAlign: "center"
    },
    modalImage: {
        borderTopLeftRadius: tokens.borderRadiusXLarge,
        borderTopRightRadius: tokens.borderRadiusXLarge
    },
    contentWrapper: {
        color: tokens.colorNeutralForeground1,
        padding: "26px"
    },
    // Try project title styles
    tryProjectTitle: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
        paddingBottom: "14px"
    },
    // Try project text styles
    tryProjectText: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        color: tokens.colorNeutralForeground2,
        paddingRight: tokens.spacingHorizontalXXL,
        paddingBottom: tokens.spacingVerticalXS
    },
    // Success content title styles
    successTitle: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase500,
        lineHeight: tokens.lineHeightBase500,
        textAlign: "center",
        verticalAlign: "middle",
        paddingBottom: "14px"
    },
    // Success content text styles
    successText: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase300,
        lineHeight: tokens.lineHeightBase300,
        textAlign: "center",
        paddingRight: tokens.spacingHorizontalXXL,
        paddingBottom: tokens.spacingVerticalXS,
        alignItems: "center",
        width: "552px",
        height: "59px"
    },
    // Try premium specific styles
    consentContainer: {
        display: "flex",
        alignItems: "center",
        gap: "5px"
    },
    userConsentText: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase100,
        lineHeight: tokens.lineHeightBase100,
        verticalAlign: "middle",
        color: tokens.colorNeutralForeground3
    },
    termsOfServiceLink: {
        fontFamily: tokens.fontFamilyBase,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase100,
        lineHeight: tokens.lineHeightBase100,
        verticalAlign: "middle"
    },
    // Provisioning styles
    trialProvisioningTitle: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase400,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase400,
        paddingTop: "30px",
        paddingBottom: "20px"
    },
    trialProvisioningText: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase300,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase300
    },
    provisionImageWrapper: {
        display: "flex",
        height: "256px",
        textAlign: "center",
        justifyContent: "center",
        marginTop: "45px"
    },
    // Success styles
    successImageHeaderWrapper: {
        display: "flex",
        height: "258px",
        justifyContent: "center"
    },
    // Error styles
    errorImageHeaderWrapper: {
        display: "flex",
        height: "128px",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "120px"
    },
    errorTitle: {
        fontWeight: tokens.fontWeightSemibold,
        fontSize: tokens.fontSizeBase400,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase400,
        paddingBottom: "10px"
    },
    errorText: {
        fontWeight: tokens.fontWeightRegular,
        fontSize: tokens.fontSizeBase300,
        textAlign: "center",
        lineHeight: tokens.lineHeightBase300,
        paddingBottom: "80px"
    },
    // Footer styles
    footerWrapper: {
        ...flexParent(),
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "40px"
    },
    dialogBody: {
        padding: "0px",
        width: "100%",
        ...flexParent("column")
    }
});
/**
 * Parameterized styles hook for TryPremiumModal component
 */ export const useTryPremiumModalStyles = (theme)=>{
    const styles = useBaseTryPremiumModalStyles();
    const isLightTheme = theme === PlannerTheme.Light;
    return {
        dialogSurface: styles.dialogSurface,
        root: styles.root,
        closeButtonContainer: styles.closeButtonContainer,
        closeButton: styles.closeButton,
        startTrialButton: styles.startTrialButton,
        imageHeaderWrapper: styles.imageHeaderWrapper,
        modalImage: styles.modalImage,
        contentWrapper: styles.contentWrapper,
        tryProjectTitle: styles.tryProjectTitle,
        successTitle: styles.successTitle,
        tryProjectText: styles.tryProjectText,
        successText: styles.successText,
        consentContainer: styles.consentContainer,
        userConsentText: styles.userConsentText,
        termsOfServiceLink: styles.termsOfServiceLink,
        trialProvisioningTitle: styles.trialProvisioningTitle,
        trialProvisioningText: styles.trialProvisioningText,
        provisionImageWrapper: styles.provisionImageWrapper,
        successImageHeaderWrapper: styles.successImageHeaderWrapper,
        errorImageHeaderWrapper: styles.errorImageHeaderWrapper,
        errorTitle: styles.errorTitle,
        errorText: styles.errorText,
        footerWrapper: styles.footerWrapper,
        dialogBody: styles.dialogBody,
        imageHeightClass: {
            height: isLightTheme ? "296px" : "324px"
        }
    };
};
